import { combineReducers } from "redux";
import PagePopupReducer from "./GeneralComponents/PagePopup/PagePopupReducer";
import PluginTriggerReducer from "./Plugins/PluginTriggerReducer";
import NavigationReducer from "./Navigation/NavigationReducer";
import DefaultPluginsReducer from "./Plugins/DefaultPluginsStore/DefaultPluginsReducer";
import DrillDownReducer from "./DrillDown/DrillDownReducer";
import WhatIfReducer from "./DashboardPage/DashboardCrud/DashboardTools/WhatIf/WhatIfReducer";
import ExpressionParameterReducer from "./ExpressionParameter/ExpressionParameterReducer";
import LoginPopupReducer from "./GeneralComponents/LoginPopup/LoginPopupReducer";
import FormulaEditorReducer from "./GeneralComponents/FormulaEditor/FormulaEditorReducer";
import PluginLoaderReducer from "./GeneralComponents/PluginLoader/PluginLoaderReducer";
import FilterAutoInteractionReducer from "./Interaction/FilterAutoInteractionReducer";
import ContextMenuReducer from "./GeneralComponents/ContextMenu/ContextMenuReducer";
import FileUploadReducer from "./FileUpload/FileUploadReducer";
import CustomDashboardReducer from "./GeneralComponents/CustomDashboard/CustomDashboardReducer";
import SettingNoDataTitleReducer from "./DashboardPage/DashboardCrud/DashboardTools/Settings/SettingList/SettingNoDataTitleReducer";
import MapChoroplethDetailReducer from "./Plugins/PluginComponents/MapChoropleth/Redux/MapChoroplethDetailReducer"
import CacheModeReducer from "./CacheMode/CacheModeReducer"
import SelfServiceReducer from "./Datasources/SelfServiceReducer/SelfServiceReducer"
import OpenPluginListReducer from "./Plugins/PluginListReducer/OpenPluginListReducer"
import SessionVariableReducer from "./GeneralComponents/SessionVariable/SessionVariableReducer";
import DashboardVariableReducer from "./GeneralComponents/DashboardVariable/DashboardVariableReducer";
import NewColumnEditorReducer from "./GeneralComponents/NewColumn/NewColumnEditorReducer";
import PieChartDataReducer from "./GeneralComponents/PieChartData/PieChartDataReducer";
import GeneralLoadingReducer from "./GeneralComponents/GeneralLoading/GeneralLoadingReducer";
import ColumnSelectorReducer from "./GeneralComponents/ColumnSelector/ColumnSelectorReducer"
import UrlParametersReducer from "./UrlParameters/UrlParametersReducer"
import NotSendedQueryPluginsReducer from "./Plugins/PluginComponents/NotSendedQueryPlugins/NotSendedQueryPluginsReducer"
import titlePrivateFunctionsReducer from "./Plugins/PluginComponents/Title/TitlePrivateFunctionReducer";
import DashboardSliderReducer from "./DashboardSlider/SliderReducer";
import PluginErrorReducer from "./GeneralComponents/PluginErrorReducer/PluginErrorReducer"
import GlobalFiltersReducer from "./DashboardPage/GlobalFilters/Redux/GlobalFiltersReducer";

export default combineReducers({
  PagePopupReducer,
  PluginTriggerReducer,
  NavigationReducer,
  DefaultPluginsReducer,
  DrillDownReducer,
  WhatIfReducer,
  ExpressionParameterReducer,
  LoginPopupReducer,
  FormulaEditorReducer,
  PluginLoaderReducer,
  FilterAutoInteractionReducer,
  ContextMenuReducer,
  FileUploadReducer,
  CustomDashboardReducer,
  SettingNoDataTitleReducer,
  CacheModeReducer,
  MapChoroplethDetailReducer,
  SelfServiceReducer,
  OpenPluginListReducer,
  NewColumnEditorReducer,
  SessionVariableReducer,
  DashboardVariableReducer,
  PieChartDataReducer,
  GeneralLoadingReducer,
  ColumnSelectorReducer,
  UrlParametersReducer,
  NotSendedQueryPluginsReducer,
  titlePrivateFunctionsReducer,
  DashboardSliderReducer,
  PluginErrorReducer,
  GlobalFiltersReducer
});